import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  setting: {
    data: {},
    loading: false,
  },
};

export const getSetting = createAsyncThunk("setting/getSetting", async () => {
  try {
    const response = await httpClient.get("/web/settings");
    return response.data;
  } catch (error) {
    const customError = {
      name: "Custom axios error",
      message: error.response.data.message,
      data: error.response.data,
    };
    throw customError;
  }
});

export const updateSetting = createAsyncThunk(
  "setting/updateSetting",
  async (setting) => {
    try {
      const response = await httpClient.put("/web/settings", setting);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSetting.pending, (state) => {
        state.setting.loading = true;
      })
      .addCase(getSetting.fulfilled, (state, action) => {
        state.setting.data = action.payload.res;
        state.setting.loading = false;
      })
      .addCase(getSetting.rejected, (state) => {
        state.setting.loading = false;
      })
      .addCase(updateSetting.pending, (state) => {
        state.setting.loading = true;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.setting.data = action.payload;
        state.setting.loading = false;
      })
      .addCase(updateSetting.rejected, (state) => {
        state.setting.loading = false;
      });
  },
});

export default settingSlice.reducer;
